import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import type { SpecificationStreamContent } from '../types/specification';

export interface GenTechnicalRequest {
    task_id: string;
    /** 操作类型 */
    operate_type?: string;
}

export type GenTechnicalResponse = {
    technical_problem: string;
    technical_methods: string;
    benefit: string;
};

export const GenTechnicalApi = Symbol.for('GenTechnicalApi');

export interface GenTechnicalApi {
    genTechnical(data: GenTechnicalRequest): PsHttpSSE<SpecificationStreamContent<GenTechnicalResponse>>;
}
